/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */

import { AnalyticsContext, AnalyticsProduct } from 'utils/analytics/events';
import { ContextCache, DispensaryContext, EcommGTMContext, GTMCartItem } from '../internal-gtm-tracker.types';
import { setItemListName } from './item-list-name';
import { PageTypes } from './get-page-type';

type EcommerceGTMMetaData = {
  context: AnalyticsContext;
  contextCache: ContextCache;
  payload?: {
    cartId: string;
    products: AnalyticsProduct[];
    dispensaryId: string;
    dispensaryName: string;
  };
  page?: PageTypes | null;
};

export const ecommerceGTMMetaData = ({
  context,
  contextCache,
  payload,
  page,
}: EcommerceGTMMetaData): EcommGTMContext => ({
  affiliation: context.activeDispensary?.name ?? contextCache.activeDispensary?.name ?? payload?.dispensaryName,
  currency: 'USD',
  value: context.activeCart?.subtotal?.toFixed(2) ?? contextCache.activeCart?.subtotal?.toFixed(2),
  item_list_name: setItemListName({ context, page }),
});

export const cartItemContext = (
  context: AnalyticsContext,
  contextCache: ContextCache,
  payload?: { cartId: string; products: AnalyticsProduct[]; dispensaryId: string; dispensaryName: string }
): EcommGTMContext => ({
  affiliation: context.activeDispensary?.name ?? contextCache.activeDispensary?.name ?? payload?.dispensaryName,
});

export const cartItemToGTMCartItem = (item): GTMCartItem => ({
  item_id: item.product.id,
  item_name: item.product.name,
  item_category: item.product.type ?? item.product.category,
  item_category_2: item.product.subcategory,
  item_variant: item.option,
  item_additional_variant: item.additionalOption,
  item_brand: item.product.brand?.name ?? item.product.brandName,
  quantity: item.quantity,
  price: item.basePrice ?? item.price ?? item.product?.Prices?.[0],
});

export const getDispensaryContext = (context: AnalyticsContext, cache: ContextCache): DispensaryContext => ({
  dispensary_id: context.activeDispensary?.id ?? cache.activeDispensary?.id ?? undefined,
  dispensary_name: context.activeDispensary?.name ?? cache.activeDispensary?.name ?? undefined,
});
